<template>
<div style="width:100%;">
  <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold">
    <b-tab active class="outlineLess">
      <template slot="title">
        <i class="fas fa-user-friends" style="padding-right:5px;"></i> Fiche
      </template>
      <p><tabFiche :infosTiers="infosTiers" /></p>
    </b-tab>

    <b-tab class="outlineLess">
      <template slot="title">
        <i class="far fa-file-alt" style="padding-right:5px;"></i> Propositions Commerciales
      </template>
      <p><tabDevis /></p>
    </b-tab>

	<b-tab class="outlineLess">
      <template slot="title">
        <i class="far fa-file-alt" style="padding-right:5px;"></i> Contrats
      </template>
      <p><tabContrat /></p>
    </b-tab>

    <b-tab class="outlineLess">
      <template slot="title">
        <i class="fas fa-file-invoice-dollar" style="padding-right:5px;"></i> Factures
      </template>
      <p><tabFactures /></p>
    </b-tab>

    <b-tab class="outlineLess">
      <template slot="title">
        <i class="far fa-calendar-check" style="padding-right:5px;"></i> Agenda
      </template>
      <p>Agenda</p>
    </b-tab>
  </b-tabs>
</div>
</template>

<script>
import tabFiche from './TabFiche';
import tabDevis from './devisFactures/TabDevis';
import tabFactures from './devisFactures/TabFactures';
import tabContrat from './contrat/TabContrat';

export default {
  components: {
    tabFiche,
    tabDevis,
	tabFactures,
	tabContrat
  },

  data () {
    return {
      
    }
  },

  mounted: function () {

  },

  methods: {

  },
  props:[
	],
  computed:{
    infosTiers(){
      return this.$store.state.infoSoc
    }
  }
}
</script>
<style>
.outlineLess {
  outline: 0;
}
</style>
